// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"4bcf4ea9","415":"0a0cdc6d","453":"51ecb064","534":"3e73e76e","659":"71f55890","687":"76eb1943","843":"160c4fbd","894":"484e0b9e","906":"b40a628b"}[chunkId] + ".chunk.js";
};